import { axios } from '@Root/API'

export const edit = (engagementId, payload) => {
	return axios.post(`student-engagement/${engagementId}/leaver`, payload)
}
